module.exports = __webpack_public_path__ + "img/dashboard.ef602890.svg";